var map = {
	"./avi2.png": 913,
	"./icon_green.png": 914,
	"./icon_red.png": 915,
	"./icon_vacio.png": 916,
	"./icon_yellow.png": 917,
	"./jpg2.png": 918,
	"./pdf2.png": 919,
	"./png2.png": 920,
	"./txt2.png": 921,
	"./xls2.png": 922
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 912;